<template lang="pug" src="./mail.pug"></template>

<script>
import { mapActions } from 'vuex'
import HtmlPreview from 'vue-html-viewer'
import { ValidationProvider, ValidationObserver } from 'vee-validate'

export default {
  components: {
    HtmlPreview,
    ValidationProvider,
    ValidationObserver
  },
  data() {
    return {
      $_veeValidate: {
        validator: 'new'
      },
      isRequired: 'required',
      campaignName: '',
      subtitle: '',
      message: '',
      buttonText: '',
      buttonLink: '',
      rules: [value => !value || value.size < 2000000 || `${this.$t('ads.FILESIZEERROR')}`],
      imgBlob: '',
      previewUrl: '',
      recipientName: '',
      recipientEmail: '',
      recipientArray: [],
      dialog: false,
      testDialog: false,
      sendDialog: false,
      checkbox01: false,
      checkbox02: false,
      checkbox03: false,
      linkToDownload: process.env.VUE_APP_API_URL+'export/userData/csv?hotspots='+window.localStorage.getItem('selectedHotspot').split('"').join('')+"&token="+window.localStorage.getItem('token').slice(1, -1)
    }
  },
  computed:{
    buttonLinkRules() {
      return this.buttonText.length ? 'url|required' : '';
    },
    selectedHs(){
      return window.localStorage.getItem('selectedHotspot').split('"').join('')
    }
  },
  methods:{
    ...mapActions(['uploadToS3AndSend', 'download', 'uploadToS3AndTest']),
    async confirmSend(){
      var valid = await this.$refs.form.validate()
      if(valid){ this.sendDialog = true }
    },
    async validateForTest(){
      var valid = await this.$refs.form.validate()
      if(valid){ this.testDialog = true }
    },
    nl2br(str){
      return str.replace(/(?:\r\n|\r|\n)/g, '<br>')
    },
    removeForTest(index){ this.recipientArray.splice(index, 1) },
    addForTest(){
      this.recipientArray.push({ nome: this.recipientName, email: this.recipientEmail })
      this.recipientName = null
      this.recipientEmail = null

      this.$refs.testObserver.reset() // limpa a validacao
    },

    async acceptDownload(){
      // /export/userData/csv?hotspots=rellicario_001
      await this.download({
        hotspots: window.localStorage.getItem('selectedHotspot').split('"').join('')
      })
      this.dialog = false
    },
    removeImg(){
      this.previewUrl = ''
      this.imgBlob = ''
    },
    async sendTest(){
      var validRecipients = await this.$refs.testObserver.validate()
      if(validRecipients){ this.addForTest() }

      if (this.buttonText.length > 0) { this.isRequired = true }else{ this.isRequired = false }

      var valid = await this.$refs.form.validate()
      if(valid){

        let bucketHs = ""
        let fileName = ""
        let bucketUrl = ""

        if(this.imgBlob !== ""){
          bucketHs = 'c_'+window.localStorage.getItem('selectedHotspot').split('"').join('').substr(0, window.localStorage.getItem('selectedHotspot').split('"').join('').indexOf('_'))
          fileName = new Date().getTime()+'.jpg'
          bucketUrl = process.env.VUE_APP_S3_BUCKET+'/email/'+bucketHs
        }

        let payload = {
          // image data
          identity: window.localStorage.getItem('selectedHotspot').split('"').join(''),
          Bucket: bucketUrl,
          Key: fileName,
          Body: this.imgBlob,
          ACL: 'public-read',
          nomeArquivo: fileName,
          // email data
          subject: this.subtitle,
          text: this.nl2br(this.message),
          image: bucketUrl+'/'+fileName,
          button: {"url": this.buttonLink, "label": this.buttonText},
          emails: this.recipientArray
        }

        await this.uploadToS3AndTest(payload)
        this.testDialog = false
      }

    },
    async send(){
      if (this.buttonText.length > 0) { this.isRequired = true }else{ this.isRequired = false }
      var valid = await this.$refs.form.validate()

      if(valid){

        let bucketHs = ""
        let fileName = ""
        let bucketUrl = ""

        if(this.imgBlob !== ""){
          bucketHs = 'c_'+window.localStorage.getItem('selectedHotspot').split('"').join('').substr(0, window.localStorage.getItem('selectedHotspot').split('"').join('').indexOf('_'))
          fileName = new Date().getTime()+'.jpg'
          bucketUrl = process.env.VUE_APP_S3_BUCKET+'/email/'+bucketHs
        }

        let payload = {
          // image data
          identity: window.localStorage.getItem('selectedHotspot').split('"').join(''),
          Bucket: bucketUrl,
          Key: fileName,
          Body: this.imgBlob,
          ACL: 'public-read',
          nomeArquivo: fileName,
          // email data
          campaignName: this.campaignName,
          subject: this.subtitle,
          text: this.nl2br(this.message),
          image: bucketUrl+'/'+fileName,
          button: {"url": this.buttonLink, "label": this.buttonText},
        }

        await this.uploadToS3AndSend(payload)
        this.sendDialog = false
      }
    },
    async onFileChange(e) {
      if(e != null){
        this.compress(e)
      }
    },
    compress(e) { // reduzir arquivo e salvar em jpeg
      const width = 700;
      const fileName = e.name
      const reader = new FileReader()
      // console.log(e)
      reader.readAsDataURL(e)
      reader.onload = event => {
          const img = new Image()
          img.src = event.target.result
          img.onload = () => {
                  const elem = document.createElement('canvas')
                  elem.width = width
                  elem.height = width * img.height / img.width

                  const ctx = elem.getContext('2d')

                  // img.width and img.height will contain the original dimensions
                  ctx.drawImage(img, 0, 0, width, width * img.height / img.width)
                  //ctx.drawImage(img, 0, 0, width, width * img.height / img.width)
                  ctx.canvas.toBlob((blob) => {
                      new File([blob], fileName, {
                          type: 'image/jpeg',
                          lastModified: Date.now()
                      });
                  }, 'image/jpeg', 1)

                  this.previewUrl = ctx.canvas.toDataURL('image/jpeg') // background do Preview
                  const newBlob = this.dataURItoBlob(ctx.canvas.toDataURL('image/jpeg'))
                  const resizedFile = new File([newBlob], "abc.jpg")
                  this.imgBlob = resizedFile // arquivo que será enviado para o S3
              },

              reader.onerror = error => console.log(error)
              // reader.readAsDataURL()
              // console.log(reader.result)
      }
    },
    dataURItoBlob(dataURI) {
        // convert base64 to raw binary data held in a string
        // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
        var byteString = atob(dataURI.split(',')[1]);
        // separate out the mime component
        var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]
        // write the bytes of the string to an ArrayBuffer
        var ab = new ArrayBuffer(byteString.length);
        // create a view into the buffer
        var ia = new Uint8Array(ab);
        // set the bytes of the buffer to the correct values
        for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        // write the ArrayBuffer to a blob, and you're done
        var blob = new Blob([ab], {type: mimeString});
        return blob;
    },
  },
  mounted(){
    //console.log(process.env.VUE_APP_API_URL)
  }
}

</script>
<style>

.frame { /* centralizar img verticalmente */
    position: relative;
}
img {
    max-height: 100%;
    max-width: 100%;
    width: auto;
    height: auto;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
}
.imgCard {
  border-color: #ffffff !important;
}
pre{ white-space: pre-wrap; }
.messagePrev{
  overflow-wrap: break-word;
  word-wrap: break-word;
  hyphens: auto;
}
</style>
